import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SliderComponent } from './slider/slider.component';
import { SliderItemComponent } from "./slider/slider-item/slider-item.component";
import { DotsComponent } from './dots/dots.components';
import { ArrowsComponent } from './arrows/arrows.component';
import { LoaderModule } from '@shopping-angular-components/loader';

@NgModule({
    declarations: [
        SliderComponent,
        SliderItemComponent,
        DotsComponent,
        DotsComponent,
        ArrowsComponent
    ],
    imports: [ 
        CommonModule,
        LoaderModule
    ],
    exports: [
        SliderComponent,
        SliderItemComponent,
        DotsComponent,
        ArrowsComponent
    ],
    providers: [],
})
export class SliderModule {}
